import React, { Component } from "react";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { connect } from "react-redux";
import { Section } from "@sunwing/components";
import { Icon } from "__ICON_REFERENCE__";

import commonUtilities from "utilities/common";
import { withLocalizer } from "utilities/withLocalizer";

import Promotion from "components/common/promotions/promotions";
import Email from "../../common/email/email";
import GroupDetails from "../../common/groupDetails/groupDetails";
import Promotions from "./promotions/promotions.js";
import ProductType from "./productType/productType";
import ProductTypeDetails from "./productTypeDetails/productTypeDetails";
import ProfileInformation from "../../common/profileInformation/profileInformation";
import RepresentativeInformation from "../../common/representativeInformation/representativeInformation";
import updateQuoteLetter from "services/quoteLetter/updateQuoteLetter.service";
import quote from "services/quote/quote.service";

import "./index.css";
import AddQuoteOption from "../../common/addQuoteOption/addQuoteOption";
import emailService from "services/email/email.service";
import { CONFIGURATION } from "utilities/configuration";

import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

class View extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPreview: this.props.isPreview || false,
            isCustomQuote: this.props.isCustomQuote || false,
            toolTipOpen: true,
            isShowEmail: false,
            isTermsAndConditions: false,
            isPricingNotes: false,
            isPromotion: false,
            emails: this.props?.emails?.data?.data?.emailList || [],
            emailListUpdated: false,
            isShowTerms: true,
            cancelTerms: {},
            isEditTerms: false,
            isShowPricing: true,
            isEditPricing: false,
            isShowPromotion: true,
            isEditPromotion: false,
            data: structuredClone(props.quote.data),
            isEmailSend: false,
            isAlertOn: true,
            termsAndConditions: this.cloneTermAndConditions(structuredClone(props.quote.data)),
            pricingNotes: this.clonePriceNotes(structuredClone(props.quote.data)),
            languageCode: this.props.languageCode ?? commonUtilities.getLanguage()
        };
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({ toolTipOpen: false });
        }, 30000); // Hide after 30 seconds
    }
    
    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    localize = (code) => {
        return this.props.localizeByLang(code, this.state.languageCode);
    };

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.quote?.data?.quoteNumber !== prevState?.data?.quoteNumber) {

            const data = structuredClone(nextProps.quote?.data || {});

            let termsAndConditions = [];
            let pricingNotes = [];

            if(data?.quoteNumber !== undefined) {
                
                // Deep clone the whole data object 
                const terms = data?.termsAndConditions;

                if (Array.isArray(terms) && terms.length > 0) {
                    terms.forEach(element => {
                        termsAndConditions.push({ ...element, isEditTerms: false, isShowTerms: true });
                    });
                }
                const _pricingNotes = data?.pricingNotes;
                if (Array.isArray(_pricingNotes) && _pricingNotes.length > 0) {
                    if(_pricingNotes?.forEach(element => {
                        pricingNotes.push({ ...element, isRemoved: false });      
                    }));
                }
            }
            
            return { data, termsAndConditions, pricingNotes };
        }
        return null;
    }

    clonePriceNotes = (data) => {
        let pricingNotes = [];
        const _pricingNotes = data?.pricingNotes;
        if (Array.isArray(_pricingNotes) && _pricingNotes.length > 0) {
            if(_pricingNotes?.forEach(element => {
                pricingNotes.push({ ...element, isRemoved: false });      
            }));
        }
        return pricingNotes;
    };

    cloneTermAndConditions = (data) => {
        let newTermAndConditions = [];
        const terms = data?.termsAndConditions;

        if (Array.isArray(terms) && terms.length > 0) {
            terms.forEach(element => {
                newTermAndConditions.push({ ...element, isEditTerms: false, isShowTerms: true });
            });
        }
        return newTermAndConditions;
    };

    handleItinerary = (event, itinerary, isItinerary) => {
        const quote = { data: structuredClone(this.state.data) }; // clone again if needed for nested changes
        let { quoteOptions } = quote?.data || [];

        quoteOptions.map((quoteOption) => {
            if (quoteOption?.deviationItinerary === null) {
                quoteOption.products.map((product) => {
                    product.itineraries?.map((quoteItinerary) => {
                        if (quoteItinerary.itineraryID === itinerary.itineraryID) {
                            if (isItinerary !== undefined && !isItinerary) {
                                quoteItinerary.isExpanded = !quoteItinerary.isExpanded;
                            } else {
                                quoteItinerary.isExpanded = true;
                                commonUtilities.scrollToSection("itinerary_" + itinerary.itineraryID, 80);
                            }
                        }
                    });
                });
            } else {
                if (quoteOption?.deviationItinerary?.itineraryID === itinerary?.itineraryID) {
                    if (isItinerary !== undefined && !isItinerary) {
                        quoteOption.deviationItinerary.isExpanded = !quoteOption.deviationItinerary.isExpanded;
                    } else {
                        quoteOption.deviationItinerary.isExpanded = true;
                        commonUtilities.scrollToSection("itinerary_" + itinerary.itineraryID, 80);
                    }
                }
            }
        });

        this.setState({ data: quote.data });
    };

    onShowEmail = () => {
        let { isShowEmail } = this.state;
        // let { emails } = this.state;
        let { quote } = this.props;
        let params = {
            quoteNumber: quote?.data?.quoteNumber
        };

        isShowEmail = true;
        this.setState({ isShowEmail });
    };

    onCustomizeQuote = () => {
        let { quote } = this.props;
        let quoteNumber = quote?.data?.quoteNumber;
        let currentType =  this.props.params?.type ?  "/" + this.props.params?.type : "";
        this.props.navigate( currentType + "/quote/" + quoteNumber + "/customize");
    };

    handleSendEmail = () => {
        let { isShowEmail, isEmailSend } = this.state;
        let { quote } = this.props;
        let { emails } = this.state;
        let params = {
            quoteNumber: quote?.data?.quoteNumber,
            emails: []
        };
        if (emails?.length > 0) {
            emails.map((eachEmail) => {
                params.emails.push(eachEmail.email);
            });
        }

        isEmailSend = true;
        isShowEmail = false;
        this.setState({ isEmailSend, isShowEmail });

        setTimeout(() => {
            isEmailSend = false;
            this.setState({ isShowEmail, isEmailSend });
        }, 5000);

        this.props.dispatch(emailService.sendEmail(params)).then(
            (response) => {
                emails = [];
                isShowEmail = false;
                this.setState({ isShowEmail, emails });
            },
            () => {
                isShowEmail = false;
                this.setState({ isShowEmail });
            }
        );
    };

    onSendEmail = () => {
        let { quote } = this.props;
        let { isEmailSend } = this.state;
        let params = {
            quoteNumber: quote?.data?.quoteNumber,
            emails: [quote?.data?.contact?.emailAddress?.email]
        };
        isEmailSend = true;
        this.setState({ isEmailSend });

        setTimeout(() => {
            isEmailSend = false;
            this.setState({ isEmailSend });
        }, 5000);

        this.props.dispatch(emailService.sendEmail(params)).then((response) => {});
    };

    closeEmailPopup = () => {
        let { isEmailSend } = this.state;
        isEmailSend = false;
        this.setState({ isEmailSend });
    };

    handleEmailCancel = () => {
        let { isShowEmail, emailListUpdated } = this.state;

        isShowEmail = false;
        emailListUpdated = false;
        this.setState({ isShowEmail, emailListUpdated });
    };

    handleEmailAdd = (email) => {
        if (email && email?.length > 0) {
            let { emails } = this.state;
            let emailAddress = { index: emails.length + 1, email: email };
            emails.push(emailAddress);
            this.setState({ emails });
        }
    };

    handleEmailDelete = (emailAddress) => {
        let { emails } = this.state;

        for (var i = 0; i < emails.length; i++) {
            if (emails[i].index === emailAddress.index) {
                emails.splice(i, 1);
            }
        }

        this.setState({ emails });
    };

    scrollToSection = (id) => {
        commonUtilities.scrollToSection(id);
    };

    showOrHideNotes = (isShow) => {
        window.scrollTo(0, 0);
        document.body.style.overflow = !isShow ? "visible" : "hidden";

        let { isPricingNotes } = this.state;
        isPricingNotes = isShow;

        this.setState({ isPricingNotes });
    };

    showOrHideTermsAndConditions = (isShow) => {
        window.scrollTo(0, 0);
        document.body.style.overflow = !isShow ? "visible" : "hidden";

        let { isTermsAndConditions } = this.state;
        isTermsAndConditions = isShow;

        this.setState({ isTermsAndConditions });
    };

    showOrHidePromotions = (flag) => {
        window.scrollTo(0, 0);
        document.body.style.overflow = !flag ? "visible" : "hidden";

        let { isPromotion } = this.state;
        isPromotion = flag;
        this.setState({ isPromotion });
    };

    onEditTerms = (id) => {

        let { termsAndConditions } = this.state;

        termsAndConditions[id].isShowTerms = !termsAndConditions[id].isShowTerms;
        termsAndConditions[id].isEditTerms = !termsAndConditions[id].isEditTerms;

        this.setState({
            termsAndConditions
        });
    };

    onCancelTerms = (id) => {

        let { termsAndConditions } = this.state;
        termsAndConditions[id].isShowTerms = true;
        termsAndConditions[id].isEditTerms = false;

        this.setState({
            termsAndConditions
        });
    };

    onChangeTerms = (event, row, value) => {

        let { termsAndConditions } = this.state;

        termsAndConditions[row][value] = event;
        this.setState({ termsAndConditions });

    };

    onChangePrice = (newValue, index) => {
        let { pricingNotes } = this.state;
        pricingNotes[index].description = newValue;
        this.setState({ pricingNotes });
    };

    onSaveTerms(id) {
        let { termsAndConditions } = this.state;
        let payload = {
            promotionInformation: null,
            pricingNotesInformation: null,
            termsAndConditions: termsAndConditions,
            groupQuoteLetter: 3
        };
        this.props.dispatch(updateQuoteLetter(payload)).then((response) => {
            // this.props.dispatch(getGroupContract());
            this.onCancelTerms(id);
            if (this.props.quote.data) {
                let { quoteNumber } = this.props.quote.data;
                this.props.dispatch(quote.get(quoteNumber)).then(response => {
                    const data = structuredClone(response?.payload?.data);
                    this.setState( { data });
                });
            }
        });
    }

    onSavePromotions() {
        let { data, isShowPromotion, isEditPromotion } = this.state;
        let promo = [];

        data.promotions?.map((eachPromotion) => {
            if (eachPromotion?.isRemoved) {
                delete eachPromotion?.isRemoved;
                promo.push(eachPromotion);
            } else {
                delete eachPromotion?.isRemoved;
            }
        });

        this.setState({ data });

        let payload = {
            promotionInformation: promo,
            pricingNotesInformation: null,
            termsAndConditions: null,
            groupQuoteLetter: 1
        };
        isShowPromotion = true;
        isEditPromotion = false;
        this.props.dispatch(updateQuoteLetter(payload)).then(
            (response) => {
                if (this.props.quote.data) {
                    let { quoteNumber } = this.props.quote.data;
                    this.props.dispatch(quote.get(quoteNumber)).then(response => {
                        const data = structuredClone(response?.payload?.data);
                        this.setState( { data });
                    });
                }
                this.setState({ isShowPromotion, isEditPromotion });
            },
            () => {
                if (this.props.quote.data) {
                    let { quoteNumber } = this.props.quote.data;
                    this.props.dispatch(quote.get(quoteNumber)).then(response => {
                        const data = structuredClone(response?.payload?.data);
                        this.setState( { data });

                    });
                }
                this.setState({ isShowPromotion, isEditPromotion });
            }
        );
    }

    onPricingSave() {
        let { pricingNotes, isShowPricing, isEditPricing } = this.state;
        let payload = {
            promotionInformation: null,
            pricingNotesInformation: pricingNotes, 
            termsAndConditions: null,
            groupQuoteLetter: 2
        };

        isShowPricing = true;
        isEditPricing = false;

        this.props.dispatch(updateQuoteLetter(payload)).then((response) => {
            if (this.props.quote.data) {
                let { quoteNumber } = this.props.quote.data;
                this.props.dispatch(quote.get(quoteNumber)).then(response => {
                    const data = structuredClone(response?.payload?.data);
                    const pricingNotes = this.clonePriceNotes(data); 
                    this.setState( { data, pricingNotes });
                });
            }
            this.setState({ isShowPricing, isEditPricing });
        },  () => {
            if (this.props.quote.data) {
                let { quoteNumber } = this.props.quote.data;
                this.props.dispatch(quote.get(quoteNumber)).then(response => {
                    const data = structuredClone(response?.payload?.data);
                    const pricingNotes = this.clonePriceNotes(data); 
                    this.setState( { data, pricingNotes });

                });
            }
            this.setState({ isShowPricing, isEditPricing });
        });
    }

    onQuoteReload = () => {

        let { quoteNumber } = this.props.quote.data;

        this.props.dispatch(quote.get(quoteNumber)).then(response => {
            if(response?.payload?.data?.quoteNumber !== undefined) {
                
                let { data } = this.state;
                data = structuredClone(response?.payload?.data);

                const termsAndConditions = this.cloneTermAndConditions(data);
                const pricingNotes = this.clonePriceNotes(data);

                this.setState( { data, termsAndConditions, pricingNotes });
            }
        });
    };

    handleClosePromotions = (value, index) => {
        let { data } = this.state;

        data.promotions[index].isRemoved = value;
        this.setState({ data });
    };

    handleClosePricing = (value, index) => {
        let { pricingNotes } = this.state;

        pricingNotes[index].isRemoved = value;
        this.setState({ pricingNotes });
    };

    onEditPromotion = (event) => {
        let { isShowPromotion, isEditPromotion, data } = this.state;
        if (data?.promotions && data?.promotions?.length > 0) {
            data?.promotions?.map((promotion) => {
                promotion["isRemoved"] = false;
            });
        }

        isShowPromotion = false;
        isEditPromotion = true;
        this.setState({
            isShowPromotion,
            isEditPromotion,
            data
        });
    };

    onCancelPromotion = () => {
        let { isShowPromotion, isEditPromotion } = this.state;
        isShowPromotion = true;
        isEditPromotion = false;
        this.setState({ isShowPromotion, isEditPromotion });
    };

    onEditPricing = (event) => {
        let { isShowPricing, isEditPricing, pricingNotes } = this.state;
        if (pricingNotes && pricingNotes?.length > 0) {
            pricingNotes?.map((pricing) => {
                pricing["isRemoved"] = false;
            });
        }

        isShowPricing = false;
        isEditPricing = true;
        this.setState({
            isShowPricing,
            isEditPricing,
            pricingNotes
        });
    };

    onCancelPricing = () => {
        let { isShowPricing, isEditPricing } = this.state;
        isShowPricing = true;
        isEditPricing = false;
        this.setState({ isShowPricing, isEditPricing });
    };

    onClose = () => {
        const { quote } = this.props;
        if(this.props.navigate) {
            this.props.navigate(
                "/lead/" +
                quote?.data?.sfdcLeadNumber +
                "/quote/" +
                quote?.data?.quoteNumber
            );
        }
    };

    closeAlert = () => {
        let isAlertOn = this.state;
        isAlertOn = false;
        this.setState({ isAlertOn });
    };

    addOptionAvailable = (isIQMUser) => {
        if(!isIQMUser && commonUtilities.isCalculatedQuote()) {
            return false;
        }
        return true;
    };

    render() {
        const quote = { data: this.state.data };
        let { profile, sfdc, email, businessLogo, canCustomize, groupTypes } = this.props;

        if(!quote?.data) return null;

        const forPDF = this.props.forPDF ?? false;

        let {
            isPreview,
            isCustomQuote,
            isShowEmail,
            emails,
            isPricingNotes,
            isTermsAndConditions,
            isPromotion,
            isShowTerms,
            isEditTerms,
            isEditPricing,
            isEditPromotion,
            isShowPricing,
            isShowPromotion,
            data,
            isEmailSend,
            isAlertOn,
            termsAndConditions,
            pricingNotes,
            toolTipOpen,
            languageCode
        } = this.state; 

        // if forPDF = true, isIQMUser should be passed in via props
        let isIQMUser = this.props.isIQMUser;
        if(isIQMUser === undefined) {
            isIQMUser = commonUtilities.isIQMUser();
        }

        const showCustomizeTooltip = (this.localize("qma-customize-quote-button-tooltip") === "show");

        return (
            <div className="row view-quote">
                <div className="quote-information-row">
                    {isPreview ? null :
                        <div className={"row box-sizing" + forPDF ? "" : " sticky"}>
                            <Section>
                                <div className="quote-header lg row">
                                    <div className="pull-left">
                                        <div className="row">
                                            {isIQMUser ? (
                                                <div className="pull-left">
                                                    {this.localize("qma-quote-number") + " "}
                                                    {quote?.data?.quoteNumber}
                                                    {".pdf"}
                                                </div>
                                            ) : (
                                                <div className="pull-left">
                                                    {this.localize("qma-quote-number") + " "}
                                                    {quote?.data?.quoteNumber}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {forPDF ? null : 
                                        <div className="print-hide pull-right">
                                            {isIQMUser ? (
                                                <div>
                                                    {" "}
                                                    <Button
                                                        data-testid={"cancel-email-contract"}
                                                        variant="outlined"
                                                        className="btn-red margin-right-1x"
                                                        onClick={() => this.onClose()}
                                                    >
                                                        {this.localize("qma-cancel-quote-letter")}
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        className="btn-white"
                                                        data-testid={"emailBtn"}
                                                        onClick={() => this.onSendEmail()}
                                                    >
                                                        <Icon
                                                            name="email"
                                                            className="pull-left icon-12 margin-right"
                                                        />
                                                        {this.localize("qma-email")}
                                                    </Button>
                                                </div>
                                            ) : (
                                                <div>
                                                    {canCustomize ? 
                                                        <Button
                                                            variant="outlined"
                                                            className={ "btn-white margin-right-1x " + languageCode }
                                                            data-testid={"emailBtn"}
                                                            onClick={() => this.onCustomizeQuote()}
                                                            data-tooltip-id={"new-button-tooltip"}
                                                            data-tooltip-delay-hide={5000}
                                                        >
                                                            <Icon
                                                                name="edit--n"
                                                                className="pull-left icon-12 margin-right"
                                                            />
                                                            {this.localize("qma-button-customize-quote")}
                                                        </Button>
                                                        : null
                                                    }
                                                    <Button
                                                        variant="outlined"
                                                        className={ "btn-white " + languageCode}
                                                        data-testid={"emailBtn"}
                                                        onClick={() => this.onShowEmail()}
                                                    >
                                                        <Icon
                                                            name="email"
                                                            className="pull-left icon-12 margin-right"
                                                        />
                                                        {this.localize("qma-email")}
                                                    </Button>
                                                    {canCustomize && toolTipOpen && showCustomizeTooltip?
                                                        <Tooltip 
                                                            id={"new-button-tooltip"}
                                                            place="bottom-end"
                                                            opacity="1"
                                                            className="button-customize-quote-tool-tip"
                                                            isOpen={toolTipOpen}
                                                            delayHide={5000}
                                                            offset="20"
                                                            clickable={true}
                                                        >
                                                            <div className="customize-quote-tool-tip-content">
                                                                <div className="d-flex tool-tip-heading">
                                                                    <div className="info">
                                                                        <span> { this.localize("qma-customize-quote-button-tooltip-heading-highlight") } </span> { this.localize("qma-customize-quote-button-tooltip-heading") }
                                                                    </div>
                                                                    <div className="close-button">
                                                                        <CloseIcon onMouseDown={e => e.preventDefault()} onClick={(e) => { e.preventDefault(); this.setState({ toolTipOpen: false });}}/>
                                                                    </div>
                                                                    
                                                                </div>
                                                                { this.localize("qma-customize-quote-button-tooltip-info") }
                                                            </div>
                                                        </Tooltip>:null
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    }
                                </div>
                            </Section>

                            {isEmailSend && !forPDF ? (
                                <div>
                                    <div className="popup-container-bg delete-modal"></div>

                                    <div className="popup-container">
                                        <div className="popup-body">
                                            <div
                                                className="close-popup-button"
                                                onClick={() => this.closeEmailPopup()}
                                            >
                                                <Icon name="close--n" className="font-icon" />
                                            </div>

                                            <div className="popup-heading margin-bottom-1x email-popup-container">
                                                <div className="email-logo-cover"></div>
                                                <div className="email-declaration-text">
                                                    {this.localize("qma-email-request")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {isShowEmail && !forPDF ? (
                                <Email
                                    isShowEmail={isShowEmail}
                                    emails={emails}
                                    handleEmailAdd={(email) => this.handleEmailAdd(email)}
                                    handleEmailDelete={(emailAddress) =>
                                        this.handleEmailDelete(emailAddress)
                                    }
                                    handleSendEmail={() => this.handleSendEmail()}
                                    handleEmailCancel={() => this.handleEmailCancel()}
                                    email={email}
                                />
                            ) : null}
                        </div>
                    }
                    {(isIQMUser || forPDF) && !isPreview ? null : (
                        <Section className="print-hide">
                            <div className={ "is-desktop link-row row grey-color-bg" + (isPreview ? "" : " margin-top-1-4")}>
                                <div className="quote-details-buttons pull-right margin-top-1-4 ">
                                    {quote?.data?.termsAndConditions !== null ? (
                                        <Button
                                            className="show-pricing-notes link-button"
                                            onClick={() => this.showOrHideTermsAndConditions(true)}
                                        >
                                            {this.localize("qma-terms-condition")}
                                        </Button>
                                    ) : null}
                                </div>
                                <div className="quote-details-buttons pull-right margin-top-1-4 margin-right border-right">
                                    {pricingNotes && pricingNotes.length > 0 ? (
                                        <Button
                                            className="link-button"
                                            onClick={() => this.showOrHideNotes(true)}
                                        >
                                            {this.localize("qma-pricing-notes")}
                                        </Button>
                                    ) : null}
                                </div>
                                <div className="quote-details-buttons pull-right margin-top-1-4 margin-right border-right">
                                    {quote?.data?.promotions !== null ? (
                                        <Button
                                            data-testid="show-all-btn"
                                            className="link-button"
                                            onClick={() => this.showOrHidePromotions(true)}
                                        >
                                            {this.localize("qma-promotions")}
                                        </Button>
                                    ) : null}
                                </div>
                            </div>
                            <div className={ "is-mobile link-row row grey-color-bg" + (isPreview ? "" : " margin-top-1-4")}>
                                <div className="pull-right margin-top-1-4 ">
                                    {quote?.data?.termsAndConditions !== null ? (
                                        <Button
                                            className="is-mobile link-button"
                                            data-testid={"termsAndConditionsBtn"}
                                            onClick={() => this.scrollToSection("termsAndConditions")}
                                        >
                                            {this.localize("qma-terms-condition")}
                                        </Button>
                                    ) : null}
                                </div>
                                <div className="pull-right margin-top-1-4 margin-right border-right">
                                    {pricingNotes && pricingNotes.length > 0 ? (
                                        <Button
                                            className="link-button"
                                            data-testid={"pricingNotesBtn"}
                                            onClick={() => this.scrollToSection("pricingNotes")}
                                        >
                                            {this.localize("qma-pricing-notes")}
                                        </Button>
                                    ) : null}
                                </div>
                                <div className="pull-right margin-top-1-4 margin-right border-right">
                                    {quote?.data?.promotions !== null ? (
                                        <Button
                                            className="link-button"
                                            data-testid={"promotionsBtn"}
                                            onClick={() => this.scrollToSection("promotions")}
                                        >
                                            {this.localize("qma-promotions")}
                                        </Button>
                                    ) : null}
                                </div>
                            </div>
                        </Section>
                    )}

                    <Section>
                        <div className="quote-information-container d-flex margin-top-2x margin-bottom-1x">
                            <div className="quote-information-col">
                                <GroupDetails group={quote?.data?.groupInformation} languageCode={this.state.languageCode} groupTypes={groupTypes} />
                            </div>

                            <div className="quote-information-col">
                                <ProfileInformation isCustomQuote={isCustomQuote} group={quote?.data?.groupInformation} profile={profile} sfdc={sfdc} forPDF={forPDF} isIQMUser={isIQMUser} languageCode={this.state.languageCode} />
                            </div>

                            <div className={"quote-information-col" + (isCustomQuote ? " business-logo" : "")}>
                                {isCustomQuote ? 
                                    <div className="business-logo-wrapper">
                                        <div className="business-logo">
                                            {businessLogo?.data?.url ? 
                                                <img src={businessLogo?.data?.url} alt="logo" />
                                                :null
                                            }
                                        </div>
                                    </div>
                                    :quote?.data?.salesRepresentative && (
                                        <RepresentativeInformation
                                            salesRepresentative={quote?.data?.salesRepresentative} forPDF={forPDF} languageCode={this.state.languageCode}
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </Section>

                    {forPDF ? null : 
                        <Section>
                            <div className="product-types-container">
                                <ProductType
                                    quote={quote?.data}
                                    handleItinerary={(event, data, isItinerary) =>
                                        this.handleItinerary(event, data, isItinerary)
                                    }
                                />
                            </div>
                        </Section>
                    }
                    {isIQMUser || forPDF ? null : (
                        quote?.data?.status?.toLowerCase() !== "confirmed" &&
                            quote?.data?.isRequote === false &&
                            this.addOptionAvailable(isIQMUser) &&
                            (quote?.data?.quoteOptions?.length < CONFIGURATION.NUMBER_OF_OPTIONS_ALLOWED) ? (
                                <Section className="print-hide">
                                    <div className="row margin-top-3x margin-reset">
                                        <AddQuoteOption data={quote?.data} groupTypes={groupTypes} events={ { reloadQuote : this.onQuoteReload }} />
                                    </div>
                                </Section>
                            ) : null
                    )}

                    <Section>
                        <ProductTypeDetails
                            quote={quote}
                            handleItinerary={(event, data, isItinerary) =>
                                this.handleItinerary(event, data, isItinerary)
                            }
                            forPDF={forPDF}
                            isCustomQuote={isCustomQuote}
                            languageCode={this.state.languageCode}
                        />
                    </Section>

                    <Section>
                        <div className="row">
                            {quote?.data?.additionalRequirements && (
                                <div className="row margin-top-1x">
                                    <div className="row-additional-information">
                                        <h3 className="margin-bottom-1x">
                                            {this.localize("qma-additional-requirement")}
                                        </h3>
                                        {commonUtilities.parseHtml(quote?.data?.additionalRequirements)}
                                    </div>
                                </div>
                            )}

                            {quote?.data?.groupInformation?.eventDetails && (
                                <div className="row margin-top-1x">
                                    <div className="row-additional-information">
                                        <h3 className="margin-bottom-1x">
                                            {this.localize("qma-event-details")}
                                        </h3>
                                        {commonUtilities.parseHtml(quote?.data?.groupInformation?.eventDetails)}
                                    </div>
                                </div>
                            )}

                            {
                                isCustomQuote ? null :
                                    (quote?.data?.contactMessageDisplayText ? <div className="row margin-top-2x background-blue font-white">
                                        <div className="row-additional-information font-20 generic-contract">
                                            {commonUtilities.parseHtml(quote?.data?.contactMessageDisplayText)}
                                        </div>
                                    </div> : null)
                            }
                        </div>
                    </Section>
                </div>

                {!isIQMUser || forPDF ? (
                    <div id="promotions" className="promotion-row background-grey avoid-break-inside">
                        <Section>
                            {quote?.data?.promotions && (
                                <Promotions promotions={quote?.data?.promotions} forPDF={forPDF} languageCode={this.state.languageCode} />
                            )}
                            {forPDF ? null :
                                <div className={isPromotion ? "overlay show" : "hide"}>
                                    <div className="close-btn-row">
                                        <Button
                                            data-testid="close-btn"
                                            variant="default"
                                            onClick={() => this.showOrHidePromotions(false)}
                                        >
                                            <Icon name="close--n" className="icon font-grey" />
                                        </Button>
                                    </div>

                                    <div className="banner background-dark font-white">
                                        <div className="banner-img"></div>
                                        <h1 className="font-white">
                                            {this.localize("qma-current-promotions")}
                                        </h1>
                                    </div>
                                    <div className="promotions-row-scroll">
                                        <Promotion promotions={quote?.data?.promotions} forPDF={forPDF} />
                                    </div>
                                </div>
                            }
                        </Section>
                    </div>
                ) : (
                    <div>
                        {quote?.data?.promotions !== null ? (
                            <div id="promotions" className="promotion-row background-grey wvi-promotion-bg avoid-break-inside">
                                <Section>
                                    <div className="quote-section-header-bar margin-top-2x">
                                        <div className="header">
                                            <Icon name="promotion" /> &nbsp;
                                            <b>Promotions</b>
                                        </div>
                                        <div className="buttons">
                                            {isShowPromotion ? (
                                                <Button
                                                    data-testid={"edit-btn"}
                                                    variant="outlined"
                                                    className="btn-white"
                                                    onClick={() => this.onEditPromotion()}
                                                >
                                                    <Icon name="edit--n" className="margin-right" />
                                                    {this.localize("qma-edit")}
                                                </Button>
                                            ) : null}

                                            {!isShowPromotion ? (
                                                <>
                                                    <Button
                                                        data-testid={"cancel-btn"}
                                                        variant="outlined"
                                                        className="btn-white cancel-button"
                                                        onClick={this.onCancelPromotion}
                                                    >
                                                        {this.localize("qma-cancel")}
                                                    </Button>
                                                    {}
                                                    <Button
                                                        data-testid={"save-btn"}
                                                        variant="outlined"
                                                        className="btn-white"
                                                        onClick={() => this.onSavePromotions()}
                                                    >
                                                        <Icon
                                                            name={"checked--n"}
                                                            className="margin-right"
                                                        />
                                                        {this.localize("qma-save")}
                                                    </Button>
                                                </>
                                            ) : null}
                                        </div>
                                      
                                    </div>
                                    <div className="row margin-top-2x">
                                        {" "}
                                        {quote?.data?.promotions && (
                                            <Promotions
                                                promotions={data?.promotions}
                                                isEdit={!isShowPromotion}
                                                handleClose={(value, index) =>
                                                    this.handleClosePromotions(value, index)
                                                }
                                                forPDF={forPDF} 
                                                languageCode={this.state.languageCode}
                                            />
                                        )}
                                    </div>
                                </Section>
                            </div>
                        ) : null}
                    </div>
                )}

                {pricingNotes && pricingNotes.length > 0 && (
                    <div id="pricingNotes">
                        <Section>
                            {forPDF ? null : 
                                <div className={isPricingNotes ? "overlay show" : "hide"}>
                                    <div className="close-btn-row">
                                        <Button
                                            data-testid="close-btn"
                                            variant="default"
                                            onClick={() => this.showOrHideNotes(false)}
                                        >
                                            <Icon name="close--n" className="icon font-grey" />
                                        </Button>
                                    </div>
                                    <div>
                                        <ul className="pricing-notes-information-row margin-top-1x">
                                            {pricingNotes.map((notes, index) => (
                                                <li key={index}>{notes.description}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            }
                            {forPDF ? null : 
                                <div className="show-pricing-notes margin-top-1x">
                                    {pricingNotes && pricingNotes.length > 0 ? (
                                        <Button
                                            variant="outlined"
                                            onClick={() => this.showOrHideNotes(true)}
                                        >
                                            {this.localize("qma-pricing-notes")}
                                        </Button>
                                    ) : null}
                                </div>
                            }
                            {!isIQMUser || forPDF ? (
                                <div className="pricing-notes-text">
                                    <div className="quote-header row margin-top-4x">
                                        <div className="d-flex">
                                            <Icon name="info--o" /> &nbsp;
                                            <b>{this.localize("qma-pricing-notes")}</b>
                                        </div>
                                    </div>
                                    <ul className="pricing-notes-information-row margin-top-1x">
                                        {pricingNotes.map((notes, index) => (
                                            <li key={index}>{notes.description}</li>
                                        ))}
                                    </ul>
                                </div>
                            ) : (
                                <div className="schedule-of-cancellation-container">
                                    <div className="quote-header row margin-top-2x row">
                                        <div className="pull-left">
                                            <div className="d-flex">
                                                <Icon name="info--o" /> &nbsp;
                                                <b>Important information and pricing</b>
                                            </div>
                                        </div>
                                        <div className="pull-right">
                                            {isShowPricing ? (
                                                <Button
                                                    data-testid={"edit-btn"}
                                                    variant="outlined"
                                                    className="btn-white"
                                                    onClick={() => this.onEditPricing()}
                                                >
                                                    <Icon name="edit--n" className="margin-right" />
                                                    {this.localize("qma-edit")}
                                                </Button>
                                            ) : null}

                                            {!isShowPricing ? (
                                                <div className="row">
                                                    <Button
                                                        data-testid={"cancel-btn"}
                                                        variant="outlined"
                                                        className="btn-white margin-right-1x cancel-button"
                                                        onClick={this.onCancelPricing}
                                                    >
                                                        {this.localize("qma-cancel")}
                                                    </Button>
                                                    {}
                                                    <Button
                                                        data-testid={"save-btn"}
                                                        variant="outlined"
                                                        className="btn-white"
                                                        onClick={() => this.onPricingSave()}
                                                    >
                                                        <Icon
                                                            name={"checked--n"}
                                                            className="margin-right"
                                                        />
                                                        {this.localize("qma-save")}
                                                    </Button>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div>
                                        {
                                            <div className="pricing-notes-text">
                                                <ul className="pricing-notes-information-row margin-top-1x">
                                                    {pricingNotes.map(
                                                        (notes, pricingIndex) => (
                                                            <li key={pricingIndex}>
                                                                {" "}
                                                                {!isEditPricing ? (
                                                                    notes.description
                                                                ) : (
                                                                    <div className="row terms-condition-container-wrapper">
                                                                        <textarea className="terms-condition-container"
                                                                            rows={5}
                                                                            id={pricingIndex}
                                                                            value={notes.description}
                                                                            onChange={(event) => this.onChangePrice(event?.target?.value, pricingIndex)}
                                                                        />
                                                                        
                                                                        <div className="margin-top-1x cross-button-pricing">{notes?.isRemoved ?
                                                                            <div onClick={() => this.handleClosePricing(false, pricingIndex)}><Icon name="refresh--o"
                                                                                className="icon-24 icon-flipped margin-left-1x margin-top close-icon" /></div>
                                                                            : <div onClick={() => this.handleClosePricing(true, pricingIndex)}><Icon name="close--o"
                                                                                className="icon-24 margin-left-1x margin-top close-icon" /></div>
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            )}
                        </Section>
                    </div>
                )}

                {quote?.data?.termsAndConditions && (
                    <div
                        id="termsAndConditions"
                        className="terms-and-conditions-information-row"
                    >
                        <Section>
                            {forPDF ? null :
                                <div className={isTermsAndConditions ? "overlay show" : "hide"}>
                                    <div className="close-btn-row">
                                        <Button
                                            data-testid="close-btn"
                                            variant="default"
                                            onClick={() => this.showOrHideTermsAndConditions(false)}
                                        >
                                            <Icon name="close--n" className="icon font-grey" />
                                        </Button>
                                    </div>

                                    <div>
                                        {Array.isArray(quote?.data?.termsAndConditions) && quote.data.termsAndConditions.map((term, index) => (
                                            <div key={index}>
                                                <div className="quote-header row margin-top-4x">
                                                    <div className="pull-left">
                                                        <div className="d-flex">
                                                            <Icon name="info--o" />&nbsp;
                                                            <b>{term.title}</b>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="content-wrapper">
                                                    {commonUtilities.parseHtml(term.description)}
                                                </div>
                                            </div>
                                        ))}

                                        {quote?.data?.noticeOfConfidentialityDisplayText &&
                                            <div className="border-top notice-Of-confidentiality-display-text">
                                                <div className="margin-top-2x">
                                                    {quote?.data?.noticeOfConfidentialityDisplayText}
                                                </div>
                                            </div>  
                                        }
                                    </div>
                                </div>
                            }
                          
                            {forPDF ? null :
                                <div className="show-pricing-notes margin-top-1x">
                                    {quote?.data?.termsAndConditions !== null ? (
                                        <Button
                                            variant="outlined"
                                            onClick={() => this.showOrHideTermsAndConditions(true)}
                                        >
                                            {this.localize("qma-terms-condition")}
                                        </Button>
                                    ) : null}
                                </div>
                            }
                            {!isIQMUser || forPDF ? (
                                <div>
                                    <div className="terms-and-conditions-text">
                                        {Array.isArray(quote?.data?.termsAndConditions) && quote.data.termsAndConditions.map((term, index) => (
                                            <div key={index}>
                                                <div className="quote-header row margin-top-4x">
                                                    <div className="d-flex">
                                                        <Icon name="info--o" />&nbsp;
                                                        <b>{term.title}</b>
                                                    </div>
                                                </div>
                                                <div className="content-wrapper">
                                                    {commonUtilities.parseHtml(term.description)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="schedule-of-cancellation-container">
                                    <div>
                                        {termsAndConditions?.map((term, index) => (
                                            !term.isEditTerms ? (
                                                <div key={index}>
                                                    <div className="quote-header row margin-top-4x">
                                                        <div className="pull-left">
                                                            <div className="d-flex">
                                                                <Icon name="info--o" /> &nbsp;
                                                                <b>{term.title}</b>
                                                            </div>
                                                        </div>
                                                        <div className="pull-right">
                                                            {term.isShowTerms ? (
                                                                <Button
                                                                    data-testid={"edit-btn"}
                                                                    variant="outlined"
                                                                    className="btn-white"
                                                                    onClick={() => this.onEditTerms(index)}
                                                                >
                                                                    <Icon name="edit--n" className="margin-right" />
                                                                    {this.localize("qma-edit")}
                                                                </Button>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="content-wrapper">
                                                        {commonUtilities.parseHtml(term.description)}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div key={index}>
                                                    <div className="quote-header row margin-top-4x">
                                                        <div className="pull-left">
                                                            <div className="d-flex">
                                                                <Icon name="info--o" /> &nbsp;
                                                                <b>{term.title}</b>
                                                            </div>
                                                        </div>
                                                        {!term.isShowTerms ? (
                                                            <div className="pull-right">
                                                                <Button
                                                                    data-testid={"cancel-btn"}
                                                                    variant="outlined"
                                                                    className="btn-white margin-right-1x cancel-button"
                                                                    id={"cancel_"+term.id}
                                                                    onClick={() => this.onCancelTerms(index)}
                                                                >
                                                                    {this.localize("qma-cancel")}
                                                                </Button>
                                                                {}
                                                                <Button
                                                                    data-testid={"save-btn"}
                                                                    variant="outlined"
                                                                    className="btn-white"
                                                                    id={"save_"+term.id}
                                                                    onClick={() => this.onSaveTerms(index)}
                                                                >
                                                                    <Icon
                                                                        name={"checked--n"}
                                                                        className="margin-right"
                                                                    />
                                                                    {this.localize("qma-save")}
                                                                </Button>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                    <textarea
                                                        className="terms-condition-container"
                                                        rows={5}
                                                        id={index}
                                                        value={term?.description}
                                                        onChange={(event) =>
                                                            this.onChangeTerms(
                                                                event?.target?.value,
                                                                index,
                                                                "description"
                                                            )
                                                        }
                                                    >
                                                    </textarea>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </div>
                            )}
                        </Section>
                    </div>
                )}

                {quote?.data?.noticeOfConfidentialityDisplayText && (
                    <Section>
                        <div className="border-top notice-Of-confidentiality-display-text">
                            <div className="margin-top-2x">
                                {quote?.data?.noticeOfConfidentialityDisplayText &&
                                quote?.data?.noticeOfConfidentialityDisplayText}
                            </div>
                        </div>
                    </Section>
                )}

                {isIQMUser && !forPDF ? (
                    <div className="margin-top-6x">
                        <div className="text-center">
                            <Button
                                data-testid={"cancel-email-contract"}
                                variant="outlined"
                                className="btn-red margin-right-1x"
                                onClick={() => this.onClose()}
                            >
                                {this.localize("qma-cancel-quote-letter")}
                            </Button>

                            <Button
                                data-testid={"save-email-group-contract"}
                                variant="outlined"
                                className="btn-blue"
                                onClick={() => this.onSendEmail()}
                            >
                                <Icon name={"email"} className="margin-right" />
                                {this.localize("qma-email")}
                            </Button>
                        </div>
                    </div>
                ) : null}

                {quote?.data === null && isAlertOn && !forPDF ? (
                    <div>
                        <div className="popup-container-bg delete-modal"></div>

                        <div className="popup-container">
                            <div className="popup-body">
                                <div
                                    className="close-popup-button"
                                    onClick={() => this.closeAlert()}
                                >
                                    <Icon name="close--n" className="font-icon" />
                                </div>

                                <div className="popup-heading margin-bottom-1x email-popup-container">
                                    <Icon
                                        name="alert--o"
                                        className="icon-12 warning-alert-prompt"
                                    />
                                    <div className="email-declaration-text">
                                        {this.localize("qma-quote-not-found")}
                                    </div>
                                    <Button
                                        className="go-back-btn"
                                        variant="contained"
                                        onClick={() => this.props.navigate("/review")}
                                    >
                                        {this.localize("qma-go-back")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(withLocalizer(View));
